module.exports = __webpack_public_path__ + "img/record.5400c2ac.png";